import React from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { StepHeader, maintenanceStepStyles } from './shared';

interface StepDetailsProps {
  title: string;
  onTitleChange: (value: string) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
}

/**
 * StepDetails - Step 3: Tell us what happened
 * Allows user to enter a brief title and description of the issue
 */
export const StepDetails: React.FC<StepDetailsProps> = ({
  title,
  onTitleChange,
  description,
  onDescriptionChange,
}) => {
  return (
    <View style={maintenanceStepStyles.container}>
      <StepHeader title="Tell us what happened" />
      
      <View style={maintenanceStepStyles.content}>
        {/* Brief Title Input */}
        <View style={styles.inputContainer}>
          <View style={styles.inputLabelRow}>
            <Text style={styles.inputLabel}>Brief title</Text>
          </View>
          <TextInput
            style={styles.inputText}
            value={title}
            onChangeText={onTitleChange}
            placeholder="Enter a brief title"
            placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
            maxLength={100}
            autoCapitalize="sentences"
            returnKeyType="next"
          />
        </View>

        {/* Description Input */}
        <View style={[styles.inputContainer, styles.textAreaContainer]}>
          <TextInput
            style={[styles.inputText, styles.textArea]}
            value={description}
            onChangeText={onDescriptionChange}
            placeholder="Description"
            placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
            multiline
            numberOfLines={4}
            textAlignVertical="top"
            maxLength={1000}
            autoCapitalize="sentences"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  inputContainer: {
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    borderRadius: 8,
    height: 40,
    paddingHorizontal: 16,
    justifyContent: 'center',
  },
  textAreaContainer: {
    height: 80,
    paddingVertical: 0,
    justifyContent: 'flex-start',
  },
  inputLabelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  inputLabel: {
    fontSize: 10,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textSecondary,
    lineHeight: 12.5,
  },
  inputText: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 17.5,
  },
  textArea: {
    flex: 1,
    textAlignVertical: 'top',
    paddingTop: 11,
    paddingBottom: 11,
    lineHeight: 21,
  },
});

export default StepDetails;
